export default "__VITE_ASSET__BC4OilgV__"